import { TimesheetWorkedTimeBlockFragment } from 'generated/resources/graphql'

export class AggregateWorkedTimeBlocksFilter {
  filteredBlocks: TimesheetWorkedTimeBlockFragment[]
  workedTimeBlocks: TimesheetWorkedTimeBlockFragment[]

  constructor(workedTimeBlocks: TimesheetWorkedTimeBlockFragment[]) {
    this.filteredBlocks = workedTimeBlocks
    this.workedTimeBlocks = workedTimeBlocks
  }

  get reset() {
    this.filteredBlocks = this.workedTimeBlocks
    return this
  }

  get regular() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.timeType === 'regular')
    return this
  }

  get overtime() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.timeType === 'overtime')
    return this
  }

  get notBreaks() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.workable)
    return this
  }

  get breaks() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => !block.workable)
    return this
  }

  get approved() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.approved) || []
    return this
  }

  get notApproved() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => !block.approved) || []
    return this
  }

  get withOutCategory() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => !block.timeRangeCategoryId) || []
    return this
  }

  get withBalancePoolType() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.poolType === 'balance') || []
    return this
  }

  get withoutBalancePoolType() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.poolType !== 'balance') || []
    return this
  }

  get withTimeSettingsCategory() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.timeRangeCategoryId) || []
    return this
  }

  get withoutTimeSettingsCategory() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => !block.timeRangeCategoryId) || []
    return this
  }

  get withApprovedTimeSettingsCategoryMinutes() {
    return this.approved.withTimeSettingsCategory.minutes > 0
  }

  get withMinutes() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.minutes > 0) || []
    return this
  }

  get minutes() {
    const mins = this.filteredBlocks.reduce((acc, block) => acc + (block.minutes || 0), 0)
    this.reset
    return mins
  }

  get notExtraHour() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => !block.extraHour) || []
    return this
  }

  get extraHour() {
    this.filteredBlocks = this.filteredBlocks.filter((block) => block.extraHour) || []
    return this
  }

  get minutesByCategory(): Record<string, number> {
    const result: Record<string, number> = {}
    for (const block of this.workedTimeBlocks) {
      if (block.timeRangeCategoryId) {
        result[block.timeRangeCategoryId] =
          (result[block.timeRangeCategoryId] || 0) + (block.minutes || 0)
      }
    }
    return result
  }
}
